

import { ThemeProvider, CssBaseline } from '@mui/material';
import React, { useEffect } from 'react';
import { LoadingContainer } from './loading-container/LoadingContainer';
import { MainRouter } from './router/main';
import { ToastAlert } from './toast-alert';
import { theme } from "./styles";
import { ModalContainer } from './modal-container';
import { useAuthService } from '../use-cases/auth';

function App() {
  const { setupSession, refresh, isValid } = useAuthService()

  useEffect(() => {
    setupSession()
  }, [setupSession])

  useEffect(() => {
    if (!isValid) return

    const intervalSeconds = Number(process.env.REACT_APP_REFRESH_INTERVAL_SECONDS);

    // Executa a renovação automática com base no intervalo do .env
    const interval = setInterval(() => {
      refresh()
    }, intervalSeconds * 1000)

    return () => clearInterval(interval)
  }, [isValid, refresh])

  return (
    <ThemeProvider theme={theme}>
      <ModalContainer />
      <CssBaseline />
      <ToastAlert />
      <LoadingContainer />
      <MainRouter />
    </ThemeProvider>
  );
}

export default App;